export default __webpack_public_path__ + "static/media/keys.d88f0242.png";